import Loadable from "@loadable/component";

const Authorization = Loadable(
  () => import(/* webpackChunkName: "authorization" */ "./authorization")
);

export default Authorization;
